
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_categorias,
} from '../../actions/auth.actions';

import {customgetoneblogdcb98_6945b60de307249250097c03, customgetblogs_6945b493e307249250097b00 } from '../../api/blogs.api'

import './articulo.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    



const lofty_value_default_categoriame9t9_6945afffe3072492500977f7 = (param) => {
	if (param === 'estrategiasdemarketing') {
		return 'Estrategias de Marketing';
	}
	if (param === 'inteligenciaartificial') {
		return 'Inteligencia Artificial';
	}
	if (param === 'sectorfintech') {
		return 'Sector Fintech';
	}
	if (param === 'tendencias') {
		return 'Tendencias';
	}
	return param;
}




const Particulo = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_categorias,
	set_lofty_global_categorias_app,

}) => {

	const [loftyres_6945b60de307249250097c03_component_iod7xu, setloftyres_6945b60de307249250097c03_component_iod7xu] = useState({});
	const [loftyres_6945b60de307249250097c03_component_il354q, setloftyres_6945b60de307249250097c03_component_il354q] = useState({});
	const [loftyres_6945b60de307249250097c03_component_ig8nfh, setloftyres_6945b60de307249250097c03_component_ig8nfh] = useState({});
	const [loftyres_6945b493e307249250097b00_component_ibx6t1, setloftyres_6945b493e307249250097b00_component_ibx6t1] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetoneblogdcb98_6945b60de307249250097c03({
					idblog: match.params.idblog,
				});
				setloftyres_6945b60de307249250097c03_component_iod7xu(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetoneblogdcb98_6945b60de307249250097c03({
					idblog: match.params.idblog,
				});
				setloftyres_6945b60de307249250097c03_component_il354q(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetoneblogdcb98_6945b60de307249250097c03({
				});
				setloftyres_6945b60de307249250097c03_component_ig8nfh(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetblogs_6945b493e307249250097b00({
					categorias: `undefined`,
				});
				setloftyres_6945b493e307249250097b00_component_ibx6t1(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);


	function function_redirigircontactanos_69461a5f8e5aed52dc8d5a49() {
		history.push("https://wa.me/50487475208");
	}


  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6942dbbe599f24ea479be766" >

      <div id="icuq" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/soluciones"
        type=""
      >
        <>Soluciones</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobregrowth"
        type=""
      >
        <>Sobre Growth</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="//casosdeexito"
        type=""
      >
        <>Casos de Éxito</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/blog"
        type=""
      >
        <>Blog</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactanos"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="ibznw" className="">
      
        <a
          target=""
          className=""
          id="ig3obt"
          href="/"
        >
          
      <img
        className=""
        id="ipd1e"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja92k5o.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="ig5a" className="">
      
        <a
          target=""
          className=""
          id="iope"
          href="/soluciones"
        >
          
    <div id="iye9" className="">
    <>SOLUCIONES</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i848v"
          href="/sobregrowth"
        >
          
    <div id="i8s6k" className="">
    <>SOBRE GROWTH</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="irmrk"
          href="/casosdeexito"
        >
          
    <div id="ib721" className="">
    <>CASOS DE ÉXITO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwshj"
          href="/blog"
        >
          
    <div id="i5dsy" className="">
    <>BLOG</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipsxb"
          href="/contactanos"
        >
          
    <div id="ii21f" className="">
    <>CONTACTO</>
    </div>
    
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="ihxuvq"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="i86fmq" className="">
      
      <div id="i1nx3a" className="">
      
      <img
        className=""
        id="i7oc7h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      
        <a
          target=""
          className=""
          id="i28n3y"
          href="#"
        >
          
      <img
        className=""
        id="isiqha"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpiasyr.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i7e9bk"
          href="#"
        >
          
      <img
        className=""
        id="iakpui"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpieb1l.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i1ecib"
          href="#"
        >
          
      <img
        className=""
        id="i3quxz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpieyc5.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="im948x"
          href="#"
        >
          
      <img
        className=""
        id="ieo7pp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpifmoh.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
      <img
        className=""
        id="i32dno"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i3v7pk" className="">
      
      <div id="igro49" className="">
      
      <div id="i9kitk" className="">
      
      <div className="" id="iqxoha">
        
      <span className="" id="">
        
      </span>
      
    <div id="" className="">
    
      <span className="" id="iu5qne">
        <>Blog </>
      </span>
      
    </div>
    
      </div>
      <>
        </>
      </div>
      
      <div className="" id="ibtwxs">
        
      <p className="MsoNormal " id="">
        
      <span className="" id="ibgcj">
        <>CÓMO LA
INNOVACIÓN DIGITAL ESTÁ TRANSFORMANDO LOS NEGOCIOS</>
    <div id="" className="">
    
    </div>
    
      </span>
      
      </p>
      
      </div>
      
      <div className="" id="i7gcar">
        <>Publicado el: 26 de agosto, 2025</>
      <br className="" id="" />
      <>Por: [Nombre del autor]</>
      </div>
      <>
        </>
      </div>
      
      <div id="imfv8r" className="">
      
      <img
        className=""
        id="icrxvd"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgti270a.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="imj4ss"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="ibs0ik" className="">
      
      <div id="ifcj8m" className="">
      
      <img
        className=""
        id="ioukt4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      
        <a
          target=""
          className=""
          id="ialaig"
          href="#"
        >
          
      <img
        className=""
        id="ig2kqn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjafo5a1.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
      <img
        className=""
        id="iuo4sf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ibeal8" className="">
      
      <div id="i8dniq" className="">
      
      <div id="iqf8wf" className="">
      
      <div className="" id="iaju4f">
        
      <span className="" id="">
        
      </span>
      
    <div id="" className="">
    
      <span className="" id="iei3a9">
        <>Artículo</>
      </span>
      
    </div>
    
      </div>
      <>
        </>
      </div>
      
        <div id="if6s7z" className="">
        
        <div className="" id="iwhysc">
          
      <div id="ioja6j" className="">
      <>
         &#123;&#123; titulo9alhu &#125;&#125;
        </>
      </div>
      
        </div>
        
        </div>
        
        <div id="iqz36d" className="">
        
      <div className="" id="i9y01g">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i443nq">
        <>Publicado el:</>
      </span>
      
      </div>
      
        <div className="" id="ilnwmi">
          
      <div id="ib1zd3" className="">
      <>
         &#123;&#123; fechapublicacionbcfjh &#125;&#125;
        </>
      </div>
      
        </div>
        
        </div>
        
        <div id="i31sjn" className="">
        
      <div className="" id="ipwom9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i41tvy">
        <>Por:</>
      </span>
      
      </div>
      
        <div className="" id="i8liq4">
          
      <div id="ilfc9t" className="">
      <>
         &#123;&#123; autor &#125;&#125;
        </>
      </div>
      
        </div>
        
        </div>
        <>
        </>
      </div>
      
      <div id="i2uron" className="">
      
      <img
        className=""
        id="ib25ft"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgti270a.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="infipn"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="i8z0pq" className="">
      
      <div id="idayon" className="">
      
      <img
        className=""
        id="iijpc6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      
        <a
          target=""
          className=""
          id="ia30fz"
          href="#"
        >
          <>
        </>
        </a>
        
      <img
        className=""
        id="iypmuz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i26goi" className="">
      
      <div id="ipc5f3" className="">
      
      <div id="igk7td" className="">
      
      <div className="" id="i3q34l">
        
      <span className="" id="">
        
      </span>
      
    <div id="" className="">
    
      <span className="" id="ibibqk">
        <>Artículo</>
      </span>
      
    </div>
    
      </div>
      <>
        </>
      </div>
      
        <div id="iod7xu" className="">
        
        <div className="" id="i22ek7">
          
          <div className="" id="">
            {loftyres_6945b60de307249250097c03_component_iod7xu?.titulob4w5}
          </div>
          
        </div>
        
        <div className="" id="iqbp5g">
          
          <div className="" id="">
            {loftyres_6945b60de307249250097c03_component_iod7xu?.autorpasa3}
          </div>
          
        </div>
        
        <div className="" id="i88n8z">
          
          <div className="" id="">
            {loftyres_6945b60de307249250097c03_component_iod7xu?.fechapublicacion5vjbz}
          </div>
          
        </div>
        
        <div className="" id="ink1x9">
          
          <div className="" id="">
            {loftyres_6945b60de307249250097c03_component_iod7xu?.descripcioncortag1oay}
          </div>
          
        </div>
        
        </div>
        <>
        </>
      </div>
      
      <div id="i62938" className="">
      
        <div id="il354q" className="">
        
        <img
          className=""
          id="ilu7gq"
          alt=""
          src={loftyres_6945b60de307249250097c03_component_il354q?.loftyUrl}
        />
        
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i7c4v6" className="">
      
      <div
        id="i68lei"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="ipo6rg" className="">
      
      <div id="i31d6s" className="">
      
      <div id="ivsxbi" className="">
      
      <div className="" id="is8apx">
        <>El futuro del trabajo: cómo la tecnología redefine nuestra manera de vivir</>
      </div>
      <>
        </>
      </div>
      
      <div id="idv6jw" className="">
      
      <div className="" id="ieaodd">
        <>El mundo laboral está cambiando más rápido que nunca. La automatización, la inteligencia artificial y el trabajo remoto han transformado la manera en que las personas se relacionan con sus empleos y empresas. Pero ¿qué significa esto para el futuro de los trabajadores y los negocios?</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="ie6tti" className="">
      
      <div className="" id="iqu12k">
        <>La transformación digital en el entorno laboral</>
      </div>
      <>
        </>
      </div>
      
      <div id="ibxrnl" className="">
      
      <div className="" id="i7xwxk">
        
      <br className="" id="" />
      <>La digitalización no solo ha mejorado la eficiencia, también ha creado nuevas oportunidades de crecimiento. Empresas de todos los tamaños están adoptando herramientas que permiten:</>
      <br className="" id="" />
      <>Colaborar en tiempo real desde cualquier parte del mundo.</>
      <br className="" id="" />
      <>Reducir costos operativos mediante procesos automatizados.</>
      <br className="" id="" />
      <>Ofrecer experiencias personalizadas a clientes y empleados.</>
      <br className="" id="" />
      <>“El futuro del trabajo no se trata de reemplazar personas con máquinas, sino de potenciar las capacidades humanas con tecnología.”</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="i33ojw" className="">
      
      <div className="" id="ilirgk">
        <>Nuevas habilidades para un nuevo mundo</>
      </div>
      <>
        </>
      </div>
      
      <div id="iq4kcw" className="">
      
      <div className="" id="i5riw1">
        
      <br className="" id="" />
      <> El mercado laboral actual exige que los profesionales desarrollen competencias digitales y blandas como:</>
      <br className="" id="" />
      <>1. Pensamiento crítico y resolución de problemas.</>
      <br className="" id="" />
      <>2. Adaptabilidad al cambio.</>
      <br className="" id="" />
      <>3. Manejo de herramientas digitales y de análisis de datos.</>
      <br className="" id="" />
      <>4.  Comunicación efectiva en entornos híbridos.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="igyr8d" className="">
      
      <div className="" id="i6ikee">
        <>El futuro del trabajo ya está aquí. Las empresas que abracen la innovación estarán mejor preparadas para enfrentar los retos del mañana, mientras que los profesionales que inviertan en aprendizaje continuo tendrán más oportunidades de crecer en un mundo cada vez más digital.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="isdd3d"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="icfo4g" className="">
      
      <div id="iba2z3" className="">
      
        <div id="ig8nfh" className="">
        
        <div className="" id="ip47vh">
          
          <div className="" id="i7h3zd">
            {loftyres_6945b60de307249250097c03_component_ig8nfh?.titulosecundario4pozg}
          </div>
          
        </div>
        
        <div className="" id="i022if">
          
          <LoftyEditorJsReadOnly id="i2106n" className="" defaultValue={loftyres_6945b60de307249250097c03_component_ig8nfh?.contenido7f3mm} />
          
        </div>
        
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i17jxt" className="">
      
      <div id="igc5yk" className="">
      
      <div className="" id="ielw3g">
        <>Artículos que te pueden interesar</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="iibrgl"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="iqkybj" className="">
      
      <div id="iienf5" className="">
      
      <div id="i7fxy7" className="">
      
      <div id="inzxwr" className="">
      
      <div id="insatf" className="">
      
      <div id="il3oig" className="">
      
      <div className="" id="i5phqf">
        <>Marketing Digital</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i6b0vh">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="ivcqgs" className="">
      
        <a
          target=""
          className=""
          id="ink6rd"
          href="#"
        >
          
      <img
        className=""
        id="i7dncy"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="iqgt7i">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i8v88l" className="">
      
      <div id="iyz1t8" className="">
      
      <div id="isjm1y" className="">
      
      <div id="i65jnc" className="">
      
      <div className="" id="i1h76n">
        <>Marketing Digital</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ipb69q">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="ijn9xz" className="">
      
        <a
          target=""
          className=""
          id="is46i3"
          href="#"
        >
          
      <img
        className=""
        id="iy354v"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="idq6ro">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="itemni" className="">
      
      <div id="ioh0jl" className="">
      
      <div id="i6sjc9" className="">
      
      <div id="ipmznw" className="">
      
      <div className="" id="iykqnb">
        <>Marketing Digital</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ig0kpr">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="ibqsfk" className="">
      
        <a
          target=""
          className=""
          id="iyjz73"
          href="#"
        >
          
      <img
        className=""
        id="ig8gpy"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="iks3d4">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="isz6mi"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="i80sfu" className="">
      
      <div id="igujpp" className="">
      
        <div id="iqseoi" className="">
        
        <div id="ipxmg4" className="">
        
      <div id="iyldrp" className="">
      
      <div id="i7n8qj" className="">
      
      <div id="iknhqm" className="">
      
      <div id="iycxab" className="">
      
        <div className="" id="i8r36t">
          
      <div id="io2bja" className="">
      <>
         &#123;&#123; titulo9alhu &#125;&#125;
        </>
      </div>
      
        </div>
        
        <div className="" id="ih4oiv">
          
      <div id="izc5op" className="">
      <>
         &#123;&#123; descripcioncortawz1jgj &#125;&#125;
        </>
      </div>
      
        </div>
        
      <div id="iju6ip" className="">
      
        <a
          target=""
          className=""
          id="idy1nl"
          href={`/article/null`}
        >
          
      <img
        className=""
        id="iik5qs"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="iy7qp7">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
        </div>
        
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="iazc41"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="iao8wl" className="">
      
      <div id="ibfxcb" className="">
      
        <div id="iqc82g" className="">
        
      <div id="iexfyv" className="">
      
      <div id="ihf17f" className="">
      
      <div id="iqqv9s" className="">
      
        <div className="" id="iadh6z">
          
      <div id="" className="">
      <>
         &#123;&#123; titulo9alhu &#125;&#125;
        </>
      </div>
      
        </div>
        
        <div className="" id="iqkw9q">
          
      <div id="iyp8nm" className="">
      <>
         &#123;&#123; descripcioncortawz1jgj &#125;&#125;
        </>
      </div>
      
        </div>
        
      <div id="i8zypl" className="">
      
      <div id="i7cazj" className="">
      
        <a
          target=""
          className=""
          id="irhap7"
          href={`/article/null`}
        >
          
      <span className="material-icons " id="i998mt">
        
      <span className="" id="iqbjhn">
        <>expand_more</>
      </span>
      
      </span>
      
      <span className="" id="i4zehw">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="icxiz8"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="i2xe9g" className="">
      
      <div id="iafoxt" className="">
      
        <div id="ibx6t1" className="">
        
            {
              loftyres_6945b493e307249250097b00_component_ibx6t1?.map((loftyitem_6945b493e307249250097b00_component_ibx6t1) => (
                <div key={loftyitem_6945b493e307249250097b00_component_ibx6t1._id} className="" id="i3l2ds">
                  
      <div id="if5j5s" className="">
      
      <div id="ikexn5" className="">
      
        <img
          className=""
          id="iigw05"
          alt=""
          src={loftyitem_6945b493e307249250097b00_component_ibx6t1?.loftyUrl}
        />
        <>
        </>
      </div>
      
      <div id="i7y3fi" className="">
      
        <div className="" id="ippz7l">
          
          <div className="" id="">
            {loftyitem_6945b493e307249250097b00_component_ibx6t1?.titulob4w5}
          </div>
          
        </div>
        
        <div className="" id="i2yijp">
          
          <div className="" id="">
            {loftyitem_6945b493e307249250097b00_component_ibx6t1?.descripcioncortag1oay}
          </div>
          
        </div>
        
      <div id="i2k8lc" className="">
      
      <div id="i3natd" className="">
      
        <a
          target=""
          className=""
          id="iww16i"
          href={`/articulo/${loftyitem_6945b493e307249250097b00_component_ibx6t1._id}`}
        >
          
      <span className="material-icons " id="iwum4f">
        
      <span className="" id="iaesc8">
        <>expand_more</>
      </span>
      
      </span>
      
      <span className="" id="is2993">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
                </div>
              ))
            }
            
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="isqkaw" className="">
      
      <div id="inwpbh" className="">
      
      <div id="iblzwv" className="">
      
      <img
        className=""
        id="i2yoxn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpsbgsp.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="imbbrp" className="">
      
      <div className="" id="i6egud">
        <>¿Listo para crecer con claridad?</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iynesv" className="">
      
      <div id="ibuain" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button2 "
        onClick={async () => {
		function_redirigircontactanos_69461a5f8e5aed52dc8d5a49();
}}

      >
      
      <div id="i4o7pt" className="">
      
      <span className="" id="i1ckiy">
        <>Escríbenos por WhatsApp</>
      </span>
      
      </div>
      
      </button>
      
      <button
        type=""
        name=""
        id="iby52g"
        className=""
        
      >
      
      </button>
      <>
        </>
      </div>
      
      <div id="ilk8u9" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		function_redirigircontactanos_69461a5f8e5aed52dc8d5a49();
}}

      >
      
      <div id="ih6ehn" className="">
      <>Agenda una cita</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iqood4" className="">
      
      <div id="i0zav2" className="">
      
      <img
        className=""
        id="ikl5d2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja92k5o.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i8xq45" className="">
      
      <div id="i6foyi" className="">
      
      <div className="" id="iujitq">
        <>1234 Pais, Ciudad, Depto,</>
      <br className="" id="" />
      <> CA</>
      </div>
      <>
        </>
      </div>
      
      <div id="i4bc65" className="">
      
      <div className="" id="i70l12">
        <>+504 123456789</>
      </div>
      <>
        </>
      </div>
      
      <div id="iuze0u" className="">
      
      <div className="" id="ijszb9">
        <>info@marketingdigital.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="il5c0x" className="">
      
        <a
          target=""
          className=""
          id="i4z9uq"
          href="/"
        >
          
      <div className="" id="iquufx">
        <>Inicio</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="itsf22"
          href="/soluciones"
        >
          
      <div className="" id="ishxo7">
        <>Soluciones</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i5y1vt"
          href="/sobregrowth"
        >
          
      <div className="" id="ilmr1e">
        <>Sobre Growth</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i0u2kc"
          href="#"
        >
          
        <a
          target=""
          className=""
          id="i36z7a"
          href="//casosdeexito"
        >
          
      <div className="" id="ibmlnj">
        <>Casos de Éxito</>
      </div>
      <>
        </>
        </a>
        <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="ibflgr"
          href="/blog"
        >
          
      <div className="" id="iq4hzi">
        <>Blog</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i8pvvw"
          href="/contactanos"
        >
          
      <div className="" id="i37aoh">
        <>Contacto</>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i9ndas" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="indubl" className="">
      
      <div id="i21uc2" className="">
      <>
        </>
      </div>
      
      <div id="inwhc2" className="">
      
      <div id="ig0f9m" className="">
      
      <img
        className=""
        id="i8uhy6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpus7um.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ippo57"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjam6dd7.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iwkvyf" className="">
      
      <div className="" id="ig7fxf">
        <>© 2025 Growth Holístico. Todos los derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
        <a
          target=""
          className=""
          id="i81q3d"
          href="https://wa.me/50487475208"
        >
          
      <img
        className=""
        id="ijpcuk"
        src="https://assetsprojects.s3.amazonaws.com/405gznimll0fka3.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_categorias_app: (value) => dispatch(set_lofty_global_categorias(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Particulo);
  